import { TPatientLocale, PREFERED_LANGUAGE } from 'src/types/locales'
import { config } from 'src/config'
import { EContentType, TContent } from './content.type'

function removeHTMLTags(htmlString: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  const textContent = doc.body.textContent || ''
  return textContent.trim()
}

function getContentExtract(content: TContent): string {
  const contentHtml = getFirstContentFromContent(content)
  const parser = new DOMParser()
  const doc = parser.parseFromString(contentHtml, 'text/html')

  const titleTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  for (const titleTag of titleTags) {
    const titleElement = doc.querySelector(titleTag as string)
    if (titleElement?.textContent) {
      return titleElement.textContent
    }
  }

  return removeHTMLTags(contentHtml)
}

const getFirstContentFromContent = (content: TContent): string => {
  const allLanguages = getContentLanguages(content)
  const firstContentKey = Object.keys(content.content)[0] as TPatientLocale
  return allLanguages.includes(PREFERED_LANGUAGE)
    ? (content.content[PREFERED_LANGUAGE] as string)
    : (content.content[firstContentKey] as string)
}

function getContentLanguages(content: TContent): string[] {
  if (content && !content?.content) return []
  const contentLanguages = [] as TPatientLocale[]
  for (const contentLanguage in content.content) {
    const hasContentThisLanguage = content.content[contentLanguage as TPatientLocale]
    hasContentThisLanguage && contentLanguages.push(contentLanguage as TPatientLocale)
  }
  return contentLanguages
}

function getPreviewUrl(content: TContent | null, locale: TPatientLocale): string | null {
  if (!content) return null
  if (content.type === EContentType.CONTENT && content.icmsSlug) {
    return `${config.PATIENT_APP_URL}/public/${content.icmsSlug}?locale=${locale}`
  }
  if (content.type === EContentType.EXTERNAL_LINK) {
    return getFirstContentFromContent(content)
  }
  return null
}

export { getContentLanguages, getContentExtract, getFirstContentFromContent, getPreviewUrl }
